/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.TranslationsRpc
 */
import * as References from './TranslationsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.TranslationsRpc#listPortalTranslations
 */
export const LIST_PORTAL_TRANSLATIONS_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_TranslationsRpc_listPortalTranslations';
export const LIST_PORTAL_TRANSLATIONS_QUERY: RegisteredQuery<
  'result',
  References.ListPortalTranslationsRequestType,
  References.ListPortalTranslationsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_PORTAL_TRANSLATIONS_QUERY_FIELD_NAME,
  args: [
    'locale',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.ListPortalTranslationsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListPortalTranslationsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listPortalTranslationsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
